"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=shorthand-types.js.map